import { AppState } from '../../../redux/reducers';
import { actionCreators as visitConceptsActions } from '../../../redux/middleware/VisitConcepts.Middleware';
import { bindActionCreators, Dispatch } from 'redux';

export interface OwnProps {
    isOpen: boolean;
    onClose: () => void;
    protocolId: number;
    visitId: number;
    patientId: string;
    ContractId: number; // Assuming ContractId is needed for the modal
}

export const mapStateToProps = (state: AppState) => ({
    visitConcepts: state.VisitConcepts?.data,
    isLoading: state.VisitConcepts?.isLoading,
    isLoadingSuccess: state.VisitConcepts?.isLoadingSuccess,
    failLoading: state.VisitConcepts?.failLoading,
    error: state.VisitConcepts?.error,
});

export const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators({
        getVisitConcepts: visitConceptsActions.getVisitConcepts,
        clearVisitConcepts: visitConceptsActions.clearVisitConcepts,
    }, dispatch);

export type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps;
